var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_18527)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.328 -12.6406H-58.1719V389.798H726.328V-12.6406Z",
    fill: "#90A8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.031 -10.9858V388.138H-56.8748V-10.9858H725.031ZM727.625 -14.3008H-59.4691V391.453H727.625V-14.3008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.601 285.072H519.164C520.979 275.002 525.275 269.221 541.06 272.059C548.16 251.352 560.26 257.402 569.451 259.959C572.355 245.302 582.711 244.603 594.228 248.794C597.022 239.136 604.002 234.368 611.333 240.649C609.584 233.433 616.8 229.016 623.549 233.317C621.338 228.433 627.388 221.916 636.694 227.619C636.578 219.705 643.904 216.801 650.653 222.73C650.653 218.775 656.351 213.424 662.17 219.243C662.401 212.494 667.059 208.771 674.616 213.077C675.084 200.977 687.646 202.957 687.646 202.957C687.646 202.957 683.114 193.343 692.183 191.787C690.759 188.525 691.265 185.099 692.227 181.32C700.708 186.105 706.67 189.185 706.67 189.185C706.67 189.185 706.181 230.952 706.94 239.334C707.787 248.613 712.088 265.069 708.601 285.072Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.625 324.005V393.801H-106.725V285.07H708.601V285.087C708.546 285.389 708.491 285.692 708.436 285.994C708.37 286.352 708.298 286.715 708.227 287.078C708.155 287.446 708.078 287.826 707.996 288.2C707.957 288.398 707.913 288.596 707.869 288.799C707.649 289.806 707.407 290.818 707.143 291.841C707.132 291.874 707.127 291.907 707.116 291.945C706.978 292.473 706.835 293.001 706.687 293.535C701.258 312.933 667.422 322.613 649.421 327.563C649.421 327.563 659.436 330.643 669.71 330.863C669.71 330.863 659.568 336.072 658.848 337.513C684.632 338.822 697.067 328.157 701.973 326.584C706.615 325.099 720.893 328.08 727.625 324.005Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.625 66.4549V324.003C720.893 328.079 706.615 325.098 701.973 326.583C697.067 328.156 684.632 338.82 658.848 337.511C659.568 336.07 669.71 330.862 669.71 330.862C659.436 330.642 649.421 327.562 649.421 327.562C667.422 322.612 701.258 312.932 706.687 293.533C706.835 293 706.978 292.472 707.116 291.944C707.127 291.905 707.132 291.872 707.143 291.839C707.407 290.816 707.649 289.804 707.869 288.798C707.913 288.594 707.957 288.396 707.996 288.198C708.078 287.824 708.155 287.445 708.227 287.076C708.298 286.713 708.37 286.35 708.436 285.993C708.491 285.69 708.546 285.388 708.601 285.085V285.069C712.088 265.065 707.787 248.609 706.94 239.331C706.181 230.949 706.67 189.182 706.67 189.182C706.67 189.182 700.708 186.102 692.227 181.317C679.264 173.996 660.415 162.688 648.007 152.315C632.272 139.154 615.029 118.633 607.852 109.778C609.436 109.03 610.888 107.991 612.081 106.731C619.22 113.183 633.251 113.183 635.572 101.655C637.403 101.908 639.009 101.88 640.417 101.616C644.581 108.59 652.039 119.156 662.973 129.947L665.965 72.8294L666.394 64.5794L682.223 61.6094L681.898 66.0589L678.983 105.681C678.901 106.77 678.857 107.864 678.835 108.959L678.257 143.169C683.086 146.804 688.344 150.302 694.042 153.52C697.447 155.439 701.005 157.26 704.723 158.948C704.723 158.948 704.553 146.826 704.784 132.796C704.965 121.807 705.394 109.646 706.335 101.215C707.842 87.7729 708.216 76.5144 706.087 69.4469C713.578 72.1034 717.841 64.8819 717.841 64.8819C717.841 64.8819 722.521 68.9519 727.625 66.4549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.658 66.1681C716.658 66.1681 721.311 70.1226 726.382 67.6971V-24.2019H529.691C527.409 -24.3853 522.165 -23.4319 519.45 -18.1519C516.735 -12.8719 520.581 -5.31858 522.844 -2.20192C520.246 -0.735252 515.05 3.73808 515.05 9.89808C515.05 16.0581 520.246 19.9957 522.844 21.1946C515.831 25.3196 514.995 37.5681 529.691 41.9791C524.934 50.0586 523.597 59.0401 534.366 62.5546C529.356 71.5361 531.638 82.3216 545.306 80.6826C545.718 95.8736 557.329 98.5686 570.853 92.6891C569.033 99.4101 576.733 112.797 590.477 100.857C591.06 103.953 592.232 106.263 593.761 107.902C593.816 107.968 593.876 108.029 593.942 108.095C594.058 108.21 594.173 108.326 594.294 108.436C594.531 108.656 594.773 108.859 595.026 109.052C595.152 109.151 595.284 109.244 595.416 109.337L595.416 109.338C595.675 109.514 595.933 109.673 596.203 109.822C596.61 110.053 597.022 110.245 597.457 110.416C597.704 110.509 597.952 110.592 598.21 110.674C598.282 110.696 598.359 110.718 598.436 110.74C599.519 111.043 600.658 111.169 601.802 111.136C601.829 111.142 601.862 111.142 601.895 111.136L602.209 111.12C602.335 111.114 602.456 111.109 602.588 111.092C602.709 111.081 602.83 111.065 602.957 111.054C603.342 111.01 603.721 110.955 604.106 110.867C604.211 110.845 604.321 110.823 604.431 110.795C604.673 110.74 604.915 110.68 605.157 110.608C605.278 110.581 605.399 110.542 605.52 110.504L605.817 110.405C605.866 110.388 605.91 110.372 605.954 110.355C606.163 110.278 606.372 110.201 606.581 110.113C606.702 110.069 606.818 110.02 606.933 109.97C607.049 109.921 607.164 109.877 607.28 109.816C608.853 109.085 610.294 108.078 611.482 106.852C618.582 113.127 632.525 113.127 634.835 101.918C636.655 102.166 638.256 102.138 639.653 101.88C639.664 101.88 639.669 101.88 639.675 101.874C639.823 101.847 639.972 101.819 640.12 101.786C640.164 101.775 640.214 101.764 640.258 101.753C640.412 101.72 640.566 101.682 640.714 101.638C640.879 101.588 641.05 101.539 641.215 101.484C641.704 101.324 642.161 101.132 642.59 100.906C642.661 100.873 642.733 100.835 642.799 100.796C642.903 100.741 643.002 100.686 643.096 100.626C643.217 100.554 643.338 100.483 643.453 100.4C643.541 100.34 643.624 100.29 643.706 100.224C643.871 100.109 644.036 99.9766 644.196 99.8446C644.278 99.7731 644.361 99.7071 644.443 99.6301C644.916 99.2121 645.334 98.7446 645.697 98.2441C645.779 98.1452 645.851 98.0354 645.922 97.9256L645.923 97.9251C646.071 97.7106 646.203 97.4961 646.329 97.2706C646.39 97.1716 646.445 97.0671 646.5 96.9681C646.979 96.0551 647.314 95.0651 647.54 94.0366C647.573 93.8771 647.6 93.7286 647.628 93.5746C647.666 93.3876 647.694 93.2061 647.716 93.0191C647.732 92.9146 647.749 92.7991 647.76 92.6891C647.776 92.552 647.787 92.4148 647.798 92.2777L647.798 92.2766L647.798 92.2748C647.809 92.1654 647.82 92.056 647.826 91.9466C647.837 91.8091 647.842 91.6716 647.842 91.5341C647.848 91.3636 647.853 91.1986 647.853 91.0281C647.853 89.5706 647.65 88.1131 647.265 86.7766C660.008 89.8731 660.69 77.4871 658.21 70.9641C658.391 71.1071 658.578 71.2501 658.771 71.3821C658.93 71.4976 659.095 71.6131 659.26 71.7176C659.271 71.7231 659.277 71.7286 659.288 71.7341C659.464 71.8496 659.645 71.9596 659.832 72.0641C660.003 72.1631 660.179 72.2621 660.36 72.3556C660.388 72.3666 660.41 72.3831 660.432 72.3941C660.773 72.5646 661.108 72.7241 661.46 72.8726C661.609 72.9331 661.752 72.9881 661.9 73.0431C662.048 73.1035 662.197 73.153 662.345 73.2024L662.346 73.2026C662.494 73.2576 662.643 73.3071 662.791 73.3511C662.945 73.3951 663.094 73.4391 663.248 73.4831C663.847 73.6536 664.458 73.7856 665.074 73.8846C666.174 74.0661 667.296 74.1376 668.407 74.1046H668.418C669.111 74.0826 669.809 74.0166 670.491 73.9231C670.645 73.9011 670.794 73.8736 670.948 73.8516C671.135 73.8241 671.322 73.7856 671.509 73.7471C671.674 73.7141 671.839 73.6756 672.009 73.6371C672.345 73.5601 672.669 73.4721 672.994 73.3731C673.153 73.3236 673.313 73.2796 673.478 73.2246C673.797 73.1201 674.105 73.0046 674.418 72.8836C674.539 72.8341 674.655 72.7901 674.776 72.7406C674.902 72.6856 675.023 72.6416 675.139 72.5811C675.293 72.5096 675.447 72.4436 675.601 72.3611C676.096 72.1136 676.569 71.8441 677.025 71.5526C677.152 71.4646 677.284 71.3876 677.405 71.2941C677.663 71.1181 677.911 70.9311 678.147 70.7386C678.378 70.5461 678.609 70.3481 678.824 70.1446C678.829 70.1391 678.835 70.1281 678.846 70.1226C679.055 69.9136 679.264 69.7046 679.456 69.4846C680.056 68.8081 680.551 68.0656 680.919 67.2626C680.996 67.1031 681.068 66.9381 681.134 66.7731C687.635 76.3981 698.838 73.4666 699.526 67.2736C699.894 67.5926 700.257 67.8841 700.615 68.1591C700.736 68.2526 700.851 68.3406 700.972 68.4286C702.386 69.4736 703.711 70.1666 704.954 70.6011L708.342 71.1676C708.496 71.1676 708.65 71.1566 708.799 71.1456C709.002 71.1346 709.211 71.1126 709.415 71.0796C709.536 71.0631 709.662 71.0411 709.778 71.0191C709.932 70.9971 710.086 70.9641 710.234 70.9256C710.37 70.9003 710.502 70.8612 710.637 70.821L710.674 70.8101C710.806 70.7771 710.944 70.7331 711.076 70.6836C711.235 70.6231 711.4 70.5626 711.56 70.4966C711.675 70.4471 711.785 70.4031 711.895 70.3536C712 70.3041 712.099 70.2601 712.192 70.2106C712.271 70.181 712.345 70.1383 712.415 70.0981L712.44 70.0841C712.968 69.7981 713.452 69.4736 713.886 69.1436C713.974 69.0721 714.062 69.0116 714.145 68.9401C714.255 68.8466 714.359 68.7641 714.458 68.6706L714.722 68.4396L714.738 68.4246C714.82 68.3477 714.897 68.2754 714.97 68.2031L715.201 67.9721C715.795 67.3671 716.207 66.8171 716.444 66.4871C716.499 66.4046 716.543 66.3441 716.581 66.2891C716.631 66.2121 716.658 66.1681 716.658 66.1681Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.803 50.9417C554.842 50.9417 555.684 50.0995 555.684 49.0607C555.684 48.0218 554.842 47.1797 553.803 47.1797C552.764 47.1797 551.922 48.0218 551.922 49.0607C551.922 50.0995 552.764 50.9417 553.803 50.9417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.527 33.1369C564.484 33.1369 565.26 32.3612 565.26 31.4044C565.26 30.4475 564.484 29.6719 563.527 29.6719C562.57 29.6719 561.795 30.4475 561.795 31.4044C561.795 32.3612 562.57 33.1369 563.527 33.1369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.766 49.2208C577.665 49.2208 578.394 48.492 578.394 47.5928C578.394 46.6937 577.665 45.9648 576.766 45.9648C575.866 45.9648 575.138 46.6937 575.138 47.5928C575.138 48.492 575.866 49.2208 576.766 49.2208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.07 71.1762C595.926 71.1762 596.621 70.4818 596.621 69.6252C596.621 68.7686 595.926 68.0742 595.07 68.0742C594.213 68.0742 593.519 68.7686 593.519 69.6252C593.519 70.4818 594.213 71.1762 595.07 71.1762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.582 35.1542C602.696 35.1542 603.6 34.2505 603.6 33.1357C603.6 32.0209 602.696 31.1172 601.582 31.1172C600.467 31.1172 599.563 32.0209 599.563 33.1357C599.563 34.2505 600.467 35.1542 601.582 35.1542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.347 74.6633C620.373 74.6633 621.206 73.831 621.206 72.8043C621.206 71.7776 620.373 70.9453 619.347 70.9453C618.32 70.9453 617.488 71.7776 617.488 72.8043C617.488 73.831 618.32 74.6633 619.347 74.6633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.368 45.9688H146.693V112.249H487.368V45.9688Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.934 112.246H146.693V219.139H156.934V112.246Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.368 112.246H476.511V219.139H487.368V112.246Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.368 219.141H146.693V319.675H487.368V219.141Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.511 205.34V219.139H156.934L202.853 205.868L476.511 205.34Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.023 63.9023H192.447V93.3493H307.023V63.9023Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.149 64.582H371.461V93.347H411.149V64.582Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.074 83.2756C210.911 76.9286 215.102 71.2031 215.102 71.2031C215.102 71.2031 219.227 74.7561 219.227 83.7156",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.125 77.9883H218.578",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.826 72.4373L225.739 84.3063C232.9 83.9653 234.368 80.2088 234.066 76.9693C233.862 74.7748 231.992 71.4473 224.826 72.4373Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.432 71.8146L244.4 84.0466L247.997 71.0391",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.086 71.5977V85.3422",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.537 71.5977C264.833 72.2577 262.704 75.7557 263.32 79.6882C264.112 84.7317 272.978 81.6847 272.978 81.6847",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.551 70.7422L281.102 73.8002L281.443 85.6307L290.072 83.1172",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.462 77.0977L281.624 79.7432",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.458 72.4297H381.609V78.3917C392.378 75.9552 390.8 88.1872 382.159 84.5957",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.64 74.2422C393.566 74.8637 392.945 78.8512 393.379 80.8917C393.99 83.7517 397.977 84.6812 403.505 82.3217",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.008 69.4961L398.389 87.5251",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.765 253.457L209.475 252.445",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.123 252.953L202.468 268.188",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.924 251.973L211.851 267.653",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.397 251.609L218.506 267.647",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.286 261.297H218.952",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.896 266.4H225.513L225.277 253.453H234.005",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.403 260.566H233.439",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.558 253.691C248.085 253.691 244.532 258.46 244.675 261.732C244.818 265.005 250.566 266.644 255.708 264.867",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.47 266.716V254.589C259.47 251.971 268.067 251.052 267.847 256.2C267.627 261.348 260.213 260.958 260.213 260.958C263.573 262.355 268.765 266.716 268.765 266.716",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.756 253.692C281.586 253.67 272.472 254.308 272.472 254.308L272.258 267.937L281.201 266.721",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.206 260.359L272.731 261.212",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.33 267.932C284.457 261.568 289.88 253.049 291.997 252.477C293.807 255.705 293.433 267.932 293.433 267.932",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.584 262.044L293.4 261.648",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.486 254.214L308.877 253.691",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.987 254.215V266.414",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.633 256.16C313.436 255.027 314.861 254.515 316.23 254.752C320.773 255.538 320.658 260.048 319.008 263.249C317.187 266.786 311.445 265.191 311.385 261.209C311.352 258.695 311.946 257.133 312.633 256.16Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.832 266.412C324.832 266.412 324.832 258.041 324.832 254.697C324.832 251.353 333.929 249.318 334.831 254.697C335.854 260.797 325.602 260.318 325.602 260.318L333.891 266.907",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.07 253.208C343.34 248.021 338.665 255.837 343.477 257.894C346.321 259.109 351.106 261.1 348.664 264.763C345.21 269.933 339.479 264.444 339.479 264.444",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.986 267.48L363.844 253.691C368.255 255.176 367.237 268.332 367.237 268.332",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.296 262.042L367.215 261.844",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.621 268.331L371.995 255.191C371.995 251.044 382.395 250.549 381.653 256.308C380.91 262.066 372.798 262.05 372.798 262.05L381.691 267.517",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.108 252.316L386.168 253.977L385.096 268.332C385.096 268.332 391.146 266.935 392.482 265.544",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.41 260.18L385.64 261.01",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.357 245.195H399.275V273.333H437.357V245.195Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.476 253.691V265.39",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 262.604V253.688L424.987 262.604L426.94 250.828",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.735 131.257C374.905 141.041 365.313 147.757 354.483 147.977C350.204 148.065 345.733 147.135 341.536 144.979C319.465 133.655 313.074 146.915 312.298 158.339C307.942 151.563 298.647 152.146 297.487 158.146C296.326 164.152 305.814 166.666 311.429 161.633C310.461 165.989 315.009 171.704 311.913 180.416C311.863 180.564 311.798 180.724 311.715 180.894C309.763 185.096 299.692 196.283 286.25 194.523C271.395 192.576 266.676 177.446 272.225 171.825C277.78 166.204 287.917 160.786 287.29 147.113C286.663 133.435 298.823 122.05 313.805 120.944C334.424 119.415 343.098 127.396 349 126.428C354.901 125.454 357.536 120.735 365.175 120.18C367.799 119.987 369.839 120.708 371.39 121.736C374.514 123.804 376.054 127.522 375.735 131.257Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.506 169.338C300.506 169.338 293.372 161.209 289.258 160.785C288.219 162.523 289.407 167.006 290.562 169.118C290.732 169.426 290.617 169.811 290.303 169.965C290.166 170.031 290.023 170.091 289.902 170.141C289.687 170.229 289.445 170.185 289.275 170.031C288.439 169.283 285.843 167.116 283.923 167.352C282.488 170.13 284.033 174.403 285.645 177.17C285.81 177.456 285.711 177.819 285.43 177.989C285.425 177.989 285.425 177.995 285.419 177.995C285.188 178.138 284.891 178.105 284.688 177.918C282.114 175.558 279.71 174.343 278.44 174.436C277.18 174.524 280.288 182.153 282.141 183.907C282.306 184.067 282.372 184.298 282.306 184.518C282.284 184.595 282.262 184.672 282.24 184.743C282.136 185.09 281.751 185.266 281.421 185.117C279.974 184.479 277.686 183.033 277.686 183.033C277.12 185.678 279.243 192.102 288.648 191.679C288.967 189.27 285.766 186.542 284.369 185.48C283.989 185.189 283.808 184.705 283.923 184.237C284.099 183.495 284.902 183.099 285.595 183.407C287.388 184.21 290.562 185.695 292.382 186.927C292.767 185.794 290.21 183.258 288.868 182.032C288.428 181.63 288.362 180.954 288.719 180.475C289.038 180.041 289.616 179.881 290.116 180.085L296.067 182.565C296.381 181.234 293.356 177.115 291.475 175.179C290.969 174.656 290.974 173.826 291.497 173.32C291.942 172.885 292.624 172.819 293.141 173.166C294.291 173.941 296.447 175.19 298.669 175.382C299.422 173.446 295.88 169.998 295.88 169.998C297.624 168.205 300.506 169.338 300.506 169.338Z",
    fill: "#90A8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.572 180.004C339.396 183.299 334.243 184.861 329.26 185.125C325.118 185.339 321.087 184.657 317.253 183.321C315.356 182.666 313.508 181.847 311.715 180.895C311.797 180.725 311.863 180.565 311.913 180.417C315.009 171.705 310.461 165.99 311.429 161.634C305.813 166.667 296.326 164.153 297.486 158.147C298.647 152.147 307.942 151.564 312.298 158.34C313.073 146.916 319.464 133.656 341.536 144.98C345.732 147.136 350.204 148.066 354.483 147.978C359.917 159.962 351.447 175.632 344.572 180.004Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.154 158.324C318.222 155.14 323.04 155.657 324.673 157.978",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.8 159.307C339.132 154.423 345.413 155.303 346.805 158.944",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.839 167.051H338.231C338.528 171.181 335.239 172.523 332.038 172.485C328.006 172.441 325.839 167.051 325.839 167.051Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.919 200.581C338.134 208.4 328.336 205.689 317.253 205.909C315.174 207.796 309.625 209.622 301.435 208.282C298.625 206.175 296.425 202.325 298.075 198.475C299.725 195.175 303.575 192.975 306.875 191.875C310.378 190.902 313.172 190.28 316.615 189.884C316.868 189.857 317.072 189.906 317.253 190.022C318.348 190.693 318.573 193.542 323.325 193.542C327.417 193.542 328.121 190.456 329.26 189.785C329.43 189.681 329.617 189.637 329.826 189.664C332.191 190.011 334.1 190.253 336.575 190.775C340.975 191.875 345.994 195.494 347.919 200.581Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.254 183.32V190.025C318.348 190.696 318.574 193.545 323.326 193.545C327.418 193.545 328.122 190.459 329.26 189.788V185.124C325.119 185.339 321.087 184.657 317.254 183.32ZM326.912 191.097C326.912 191.477 326.604 191.785 326.224 191.785H319.646C319.261 191.785 318.953 191.477 318.953 191.097V186.862C318.953 186.477 319.261 186.169 319.646 186.169H321.098C321.357 186.169 321.593 186.318 321.714 186.543L322.803 188.666C322.919 188.897 323.155 189.04 323.414 189.04H326.224C326.604 189.04 326.912 189.348 326.912 189.733V191.097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.911 189.732V191.096C326.911 191.475 326.603 191.783 326.224 191.783H319.646C319.261 191.783 318.953 191.475 318.953 191.096V186.861C318.953 186.476 319.261 186.168 319.646 186.168H321.098C321.356 186.168 321.593 186.316 321.714 186.542L322.803 188.665C322.918 188.896 323.155 189.039 323.413 189.039H326.224C326.603 189.039 326.911 189.347 326.911 189.732Z",
    fill: "#98282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.4 214.022C312.98 214.462 304.308 210.63 301.65 208.659C303.208 208.155 306.875 206.762 309.075 205.222C311.275 203.682 313.383 201.647 314.163 200.822C317.497 202.369 321.588 203.466 328.6 203.366C347.884 203.091 350.153 199.275 354.759 198.415C359.855 197.463 365.45 198.622 364.763 207.147C364.68 208.169 364.452 209.06 364.113 209.836C361.05 214.624 354.278 215.243 353.384 212.957C353.167 212.401 353.679 212.072 354.36 211.836C353.445 212.032 352.47 212.166 351.7 212.097C347.884 211.754 348.297 210.963 346.509 210.963C344.722 210.963 343.175 213.472 326.4 214.022Z",
    fill: "#98282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.266 206.236C358.266 206.236 359.377 206.411 361.05 207.147C362.769 207.903 363.413 209.169 364.113 209.836M364.113 209.836C361.05 214.624 354.278 215.243 353.384 212.957C352.961 211.874 355.309 211.65 356.272 211.307C359.236 210.25 354.296 212.33 351.7 212.097C347.884 211.754 348.297 210.963 346.509 210.963C344.722 210.963 343.175 213.472 326.4 214.022C312.98 214.462 304.308 210.63 301.65 208.659C303.208 208.155 306.875 206.762 309.075 205.222C311.275 203.682 313.383 201.647 314.163 200.822C317.497 202.369 321.588 203.466 328.6 203.366C347.884 203.091 350.153 199.275 354.759 198.415C359.855 197.463 365.45 198.622 364.763 207.147C364.68 208.169 364.452 209.06 364.113 209.836ZM359.263 202.266C359.263 202.266 361.05 202.472 362.288 203.366C363.525 204.26 363.789 204.658 364.785 205.626",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.176 253.589C643.172 253.589 644.79 251.634 644.79 249.222C644.79 246.811 643.172 244.855 641.176 244.855C639.18 244.855 637.563 246.811 637.563 249.222C637.563 251.634 639.18 253.589 641.176 253.589Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.497 277.703C622.424 277.703 623.175 276.952 623.175 276.025C623.175 275.099 622.424 274.348 621.497 274.348C620.571 274.348 619.82 275.099 619.82 276.025C619.82 276.952 620.571 277.703 621.497 277.703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.179 263.991C612.324 263.991 613.253 263.062 613.253 261.917C613.253 260.772 612.324 259.844 611.179 259.844C610.034 259.844 609.106 260.772 609.106 261.917C609.106 263.062 610.034 263.991 611.179 263.991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.901 268.669C591.803 268.669 592.534 267.938 592.534 267.036C592.534 266.134 591.803 265.402 590.901 265.402C589.998 265.402 589.267 266.134 589.267 267.036C589.267 267.938 589.998 268.669 590.901 268.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.982 340.311C637.409 337 642.744 336.923 645.747 340.916C646.264 341.604 646.071 342.588 645.351 343.05C639.845 346.57 635.726 343.842 633.999 342.242C633.438 341.725 633.438 340.839 633.982 340.311Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.404 342.997C550.619 342.326 550.234 341.6 549.563 341.396C544.618 339.895 541.285 342.348 541.038 344.883C540.796 347.342 549.167 346.902 550.404 342.997Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.938 334.344C296.728 336.214 297.41 342.33 303.757 343.424C310.098 344.519 310.874 338.881 310.874 338.881C310.874 338.881 306.677 337.996 303.938 334.344Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.227 295.536C131.705 294.266 131.007 292.869 129.714 292.445C125.342 291.021 122.674 292.99 122.493 295.41C122.306 297.764 129.703 299.568 131.227 295.536Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.588 317.741C84.18 312.653 76.2105 314.677 76.3975 318.907C76.579 323.131 86.1985 322.152 85.588 317.741Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.77609 304.457C-4.01259 304.006 -3.99608 303.45 -3.72658 303.021C-0.932584 298.544 5.98641 300.524 6.22841 303.423C6.47041 306.36 -0.59709 310.474 -3.77609 304.457Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4715 334.503C18.433 334.118 18.268 333.75 17.9985 333.475C14.9075 330.312 9.34704 334.618 10.4525 337.198C11.569 339.794 18.9335 339.437 18.4715 334.503Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9385 307.543C34.9385 307.543 37.3365 313.301 40.4275 314.726",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4501 301.695C46.4501 301.695 46.3731 305.171 47.6876 306.953",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1281 335.578C43.1281 335.578 44.2886 339.027 47.0716 340.886",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8556 332.359V335.934",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7501 326.195V330.678",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1836 300C71.1836 300 74.9731 304.67 75.7431 307.552",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9869 296.828L80.4564 305.485",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0226 297.598L85.6156 304.324",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.833 359.84L324.302 368.497",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.868 360.609L329.461 367.336",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.756 311.977L116.553 321.613",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.246 309.121L121.42 318.631",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.979 307.551C124.979 307.551 125.562 313.991 126.931 315.768",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.554 360.898C429.554 360.898 430.137 367.339 431.507 369.115",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.923 333.931C112.923 333.931 118.951 331.687 124.671 333.931",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.525 336.79L149.867 333.93",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.953 346.453L136.958 346.838",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.734 338.261C171.427 338.261 184.643 336.793 184.643 336.793",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.223 343.204L201.418 341.043",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.508 337.098L257.215 344.363",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.249 332.77L263.865 339.573",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.998 331.379L274.915 337.484",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.503 338.959L339.198 336.215",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.018 336.217L359.895 334.43",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.478 340.468C382.478 340.468 385.69 338.966 389.282 338.961",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.732 336.215H415.55",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.009 337.588L437.945 336.879",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.893 342.261L458.169 341.508",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.352 329.32L470.357 338.104",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.436 326.102C472.436 326.102 472.722 331.959 474.229 334.605",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.871 323.363C483.871 323.363 479.333 327.807 483.871 332.812",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.384 317.887L495.778 326.104",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.66 300.875L502.961 309.098",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.368 340.182C487.368 340.182 491.147 339.049 493.699 339.522",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.252 343.4C508.252 343.4 510.991 342.173 512.883 342.267",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.632 322.613C520.632 322.613 517.327 328.19 518.647 330.363",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.121 321.285L527.436 326.483",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.811 308.438C539.811 308.438 536.313 315.901 538.585 317.886",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.901 323.363C546.901 323.363 546.994 329.98 549.359 330.827",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.862 319.676V326.479",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.257 309.094V317.03",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.499 300.309H587.441",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.554 359.281H48.4959",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.737 300.305L604.414 299.738",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.792 359.281L65.469 358.715",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.707 317.888L595.757 317.035",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.906 315.996H610.97",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.049 299.176C613.049 299.176 609.743 305.127 611.723 307.112",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.104 358.148C74.104 358.148 70.7985 364.099 72.7785 366.085",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.464 295.297C626.464 295.297 622.399 302.386 624.478 304.366",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5184 354.273C87.5184 354.273 83.4539 361.363 85.5329 363.343",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.485 295.863C636.485 295.863 633.933 300.307 634.406 302.194",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5395 354.84C97.5395 354.84 94.9875 359.284 95.4605 361.17",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.707 330.359C589.707 330.359 589.421 339.808 594.245 339.242",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.076 331.867C601.076 331.867 600.289 338.291 603.787 338.385",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.07 327.098C612.07 327.098 611.971 332.438 611.091 335.128",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.685 321.668C622.685 321.668 619.946 327.525 620.419 329.604",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.557 312.191L642.32 311.465",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.12 355.551L125.138 356.068",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2365 285.072H-105.641V202.599C-94.3775 198.111 -82.492 205.426 -79.335 215.568C-70.854 214.567 -60.217 220.221 -60.217 230.693C-53.067 230.528 -45.0865 231.859 -41.7645 246.819C-32.783 241.501 -23.642 245.659 -20.815 257.627C-7.18599 253.804 -6.85049 267.934 -6.85049 267.934C-6.85049 267.934 2.62601 262.45 6.28351 273.918C15.4245 273.252 22.2445 277.245 25.2365 285.072Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6575 105.002H-105.41V36.0156C-88.795 36.0156 -85.2145 50.9481 -85.2145 50.9481C-69.3855 43.7816 -61.174 54.3801 -60.2775 60.0561C-45.8455 55.1061 -37.8815 64.6871 -37.4305 70.5061C-28.9715 64.8246 -15.48 68.5646 -14.886 78.4206C-5.11246 71.6501 2.61504 80.9231 1.30054 85.3286C9.95754 77.6011 18.7685 83.5411 18.5375 89.9981C26.7325 83.9371 34.999 90.9661 33.7615 95.9161C42.4955 93.7546 50.6575 105.002 50.6575 105.002Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.293 285.068H25.2365C22.2445 277.241 15.4245 273.248 6.28352 273.914C2.62602 262.446 -6.85048 267.93 -6.85048 267.93C-6.85048 267.93 -7.18598 253.8 -20.815 257.623C-23.642 245.655 -32.783 241.497 -41.7645 246.815C-45.0865 231.855 -53.067 230.524 -60.217 230.689C-60.217 220.217 -70.854 214.563 -79.335 215.564C-82.492 205.422 -94.3775 198.107 -105.641 202.595V90.5766C-97.1935 87.7771 -93.0355 95.8071 -92.9145 102.38C-80.9905 100.433 -76.849 109.315 -76.244 116.256C-66.751 113.699 -59.447 120.392 -60.1785 133.658C-47.0335 131.832 -41.803 141.204 -40.7085 154.47C-27.4425 152.034 -22.696 161.89 -25.9795 171.141C-17.8285 170.167 -13.082 177.224 -12.7135 186.926C-2.97848 187.256 -1.15248 193.652 -3.58898 204.608C4.80952 204.487 8.94553 209.234 7.73003 218.969C14.3025 214.222 24.2795 216.356 23.5535 227.73C34.867 222.252 41.929 223.836 43.513 235.887C48.254 233.571 55.921 231.624 59.21 241.117C68.582 234.666 76.3315 236.316 75.611 247.156C82.6565 244.989 87.898 246.975 89.8835 256.011C99.096 252.755 103.612 258.717 102.891 266.307C106.142 264.679 115.717 265.763 114.815 274.436C125.837 275.157 125.293 285.068 125.293 285.068Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6389 272.399C93.5107 272.399 94.2174 271.692 94.2174 270.821C94.2174 269.949 93.5107 269.242 92.6389 269.242C91.7672 269.242 91.0604 269.949 91.0604 270.821C91.0604 271.692 91.7672 272.399 92.6389 272.399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6935 277.512C54.7324 277.512 55.5745 276.67 55.5745 275.631C55.5745 274.592 54.7324 273.75 53.6935 273.75C52.6547 273.75 51.8125 274.592 51.8125 275.631C51.8125 276.67 52.6547 277.512 53.6935 277.512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4155 263.524C73.5363 263.524 74.445 262.615 74.445 261.494C74.445 260.373 73.5363 259.465 72.4155 259.465C71.2946 259.465 70.386 260.373 70.386 261.494C70.386 262.615 71.2946 263.524 72.4155 263.524Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2395 261.419C51.1113 261.419 51.818 260.712 51.818 259.84C51.818 258.968 51.1113 258.262 50.2395 258.262C49.3677 258.262 48.661 258.968 48.661 259.84C48.661 260.712 49.3677 261.419 50.2395 261.419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3774 263.981C35.4983 263.981 36.4069 263.072 36.4069 261.951C36.4069 260.831 35.4983 259.922 34.3774 259.922C33.2565 259.922 32.3479 260.831 32.3479 261.951C32.3479 263.072 33.2565 263.981 34.3774 263.981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3616 243.16C19.2364 243.16 19.9456 242.451 19.9456 241.576C19.9456 240.701 19.2364 239.992 18.3616 239.992C17.4868 239.992 16.7776 240.701 16.7776 241.576C16.7776 242.451 17.4868 243.16 18.3616 243.16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.398618 233.566C1.29166 233.566 2.01562 232.842 2.01562 231.949C2.01562 231.056 1.29166 230.332 0.398618 230.332C-0.494427 230.332 -1.21838 231.056 -1.21838 231.949C-1.21838 232.842 -0.494427 233.566 0.398618 233.566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.685 173.587H558.709C558.709 173.587 555.761 168.114 548.792 170.039C547.208 166.085 541.972 164.913 536.137 169.247C533.42 164.6 527.683 159.463 520.715 165.887C515.968 158.819 506.283 158.869 501.586 162.031C497.087 154.865 486.362 152.544 474.498 154.815C470.544 155.211 465.209 159.067 465.209 159.067C465.209 159.067 459.769 152.72 449.605 157.455C439.441 162.196 441.685 173.587 441.685 173.587Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.632 6.96972H289.492C289.492 6.96972 292.141 1.49721 298.402 3.42221C299.825 -0.532286 304.529 -1.70379 309.772 2.63021C312.213 -2.01729 317.367 -7.15428 323.628 -0.730279C327.892 -7.79778 336.594 -7.74828 340.814 -4.58578C344.857 -11.7523 354.492 -14.0733 365.151 -11.8018C368.704 -11.4058 373.497 -7.55028 373.497 -7.55028C373.497 -7.55028 378.384 -13.8973 387.516 -9.16178C396.648 -4.42078 394.632 6.96972 394.632 6.96972Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.763 74.1286H54.249C54.249 61.8691 69.308 47.0741 81.8315 64.0581C86.2975 60.7306 93.563 54.2901 98.9915 65.2571C105.119 60.2906 110.547 59.0641 115.717 66.3351C120.359 61.8691 126.052 60.8186 129.027 66.7751C133.493 62.8371 138.135 63.5356 139.098 67.3031C142.777 62.5731 153.106 65.2626 153.106 65.2626L166.763 74.1286Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.158 311.191L214.827 319.672",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.968 310.512L219.92 319.675",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.284 307.371V319.675",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.206 308.828L413.988 319.68",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.238 307.855L402.993 319.675",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.064 307.457L397.295 319.678",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.15 310.023C389.32 310.139 394.677 319.681 394.677 319.681",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.481 140.723L349.467 136.23C349.434 136.18 349.467 136.109 349.533 136.109H352.652C352.696 136.109 352.729 136.076 352.729 136.037L352.894 133.524C352.899 133.463 352.96 133.43 353.009 133.463L355.325 134.778C355.363 134.8 355.413 134.783 355.435 134.745L357.046 131.461C357.068 131.423 357.118 131.406 357.156 131.428L360.049 133.117C360.088 133.139 360.143 133.122 360.159 133.078L361.699 129.366C361.721 129.311 361.793 129.3 361.831 129.344L364.576 132.655C364.614 132.704 364.697 132.688 364.713 132.627L366.407 126.83C366.424 126.77 366.506 126.753 366.545 126.803L368.057 128.651C368.068 128.667 368.074 128.684 368.074 128.7V136.208C368.074 136.279 367.986 136.312 367.936 136.263L365.687 133.804C365.67 133.788 365.648 133.777 365.626 133.777H364.207C364.163 133.777 364.13 133.815 364.13 133.854L364.191 138.028C364.191 138.078 364.147 138.116 364.097 138.105L362.068 137.682C362.04 137.676 362.018 137.66 362.013 137.632L360.511 133.892C360.489 133.837 360.418 133.826 360.379 133.87L359.037 135.482C359.026 135.493 359.021 135.515 359.021 135.531L358.905 140.613C358.905 140.652 358.872 140.685 358.834 140.69L357.162 140.855C357.123 140.861 357.09 140.833 357.079 140.8L355.759 136.087C355.748 136.048 355.71 136.021 355.671 136.032L353.834 136.373C353.807 136.378 353.779 136.4 353.774 136.428L352.63 140.701C352.608 140.767 352.52 140.778 352.481 140.723Z",
    fill: "#90A8ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_18527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid10);
export default __webpack_public_path__ + "static/media/grid10.07a54c653970d6669b7e1341900873f9.svg";
export { ForwardRef as ReactComponent };